// extracted by mini-css-extract-plugin
export default {"circle":"Stepper_circle__KsLOU","activeLabel":"Stepper_activeLabel__vqDIE","activeContent":"Stepper_activeContent__GXeKl","verticalStep":"Stepper_verticalStep__Ipuek"};